export enum OfferPriceInfoEnum {
  Text = 'Kup teraz, aby uniknąć zmiany ceny.',
  TextHigher = 'Cena oferty wzrosła.',
  TextLower = 'Kup teraz w\xa0niższej\xa0cenie.',
  Title = 'Zarezerwuj cenę! ',
  TitleHigher = 'Kup teraz, aby uniknąć kolejnych podwyżek. ',
  TitleLower = 'Cena oferty spadła! ',
}
